import { render, staticRenderFns } from "./deanSectionTitle.vue?vue&type=template&id=117052f2&scoped=true"
import script from "./deanSectionTitle.vue?vue&type=script&lang=ts"
export * from "./deanSectionTitle.vue?vue&type=script&lang=ts"
import style0 from "./deanSectionTitle.vue?vue&type=style&index=0&id=117052f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117052f2",
  null
  
)

export default component.exports